module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAARCAMAAADXCB3qAAAARVBMVEXxmKfxmKfxmKf////4zNP4ydHxmKf//v7//f3//f3//f375Oj62uD//v7//f3//f387O/86u386Oz74OX4ytL4ytL///9zvFnPAAAAFnRSTlMdGyH4PjIf8OLf21lP9OXVaWRfVDk3iU5ZygAAAFBJREFUCNc1zVsOgCAMRNFpRUDBt3b/S7Ut8HVP0qSDygwQEVLl6JD0MACFbKVDpuIw3QbXBYXr7JCjY50x6li0sH7tT36jI4e2tQdu0NqFfrd6BZ2DF17YAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jianja.png
// module id = 17uc
// module chunks = 1